import * as React from "react"

export const ExpiredTrialAlertWindow = ({
    isOpen,
    handleCloseAlert,
    team,
    userId,
    type,
    upgrade,
    accountName,
}) => {
    // if there is no team and type is time entry, do not show alert
    if (!team && type === "TIME_ENTRY") {
        return null
    }

    return (
        <div className={`alert-window ${!isOpen && "hidden"}`}>
            <i
                className="fa fa-times inline-icon close-button"
                aria-hidden="true"
                onClick={handleCloseAlert}
            />
            {computeAlertModalText(team, userId, type, upgrade, accountName)}
        </div>
    )
}

export const computeAlertModalText = (
    team,
    userId,
    type,
    upgrade,
    yourAccountName,
) => {
    const accountName = yourAccountName || "your account"
    const teamName = (team && team.name) || ""
    const teamOwnerEmail = (team && team.teamOwnerEmail) || ""
    const teamOwnerName =
        team && !!team.teamOwnerName ? (
            <span>
                {" "}
                {team.teamOwnerName} at{" "}
                <a
                    href={`mailto:${teamOwnerEmail}?subject=Upgrade ${teamName} to Shoutbase Premium`}
                >
                    {" "}
                    {teamOwnerEmail}
                </a>{" "}
            </span>
        ) : (
            <a> {teamOwnerEmail}</a>
        )
    const isTeamOwner = team && team.ownerId == userId
    const hasEndedMessage = <p>The free trial for {teamName} has ended.</p>
    const contactTeamOwnerToUpgrade = <p>Contact {teamOwnerName} to upgrade.</p>
    const upgradeNowLink = (
        <span className="link-text" onClick={upgrade}>
            upgrade now!
        </span>
    )

    if (type === "TIME_ENTRY") {
        const toContinueText = isTeamOwner ? (
            <p>
                To continue tagging new time entries for {teamName},{" "}
                <span className="link-text" onClick={upgrade}>
                    upgrade to a paid plan.
                </span>
            </p>
        ) : (
            <div>
                <p>
                    To continue tagging new time entries for {teamName}, the
                    team owner can upgrade to a paid plan.
                </p>
                {contactTeamOwnerToUpgrade}
            </div>
        )
        return (
            <div>
                {hasEndedMessage}
                {toContinueText}
                <p>
                    To finish creating this time entry, you may remove the{" "}
                    {teamName} tags for now.
                </p>
            </div>
        )
    }
    if (type === "TEAM_INVITE") {
        return (
            <div>
                {hasEndedMessage}
                {isTeamOwner ? (
                    <p>To invite a new member, {upgradeNowLink}</p>
                ) : (
                    contactTeamOwnerToUpgrade
                )}
            </div>
        )
    }
    if (type === "TAG") {
        return (
            <div>
                {hasEndedMessage}
                {isTeamOwner ? (
                    <p>
                        To create a new tag for {teamName}, {upgradeNowLink}
                    </p>
                ) : (
                    contactTeamOwnerToUpgrade
                )}
            </div>
        )
    }
    if (type === "TEAM") {
        return (
            <div>
                <p>The free trial for {accountName} has ended.</p>{" "}
                <p>
                    To create a new team for {accountName}, {upgradeNowLink}
                </p>
            </div>
        )
    }
    return ""
}



// WEBPACK FOOTER //
// ./src/components/alert_window.jsx